import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import modImage from "../assets/images/other/modular-house-example.webp";

const ModularHousingPlan = () => {
  return (
    <Container>
      <ImageContent>
        <StyledImage src={modImage} alt="Modular house factory floor" />
      </ImageContent>
      <TextContent>
        <CenteredTitle>
          Innovation to Address Affordable Housing Needs
        </CenteredTitle>
        <Title>
          Introducing the Future Habitat Buffalo Modular Housing Factory
        </Title>
        <Description>
          Our Modular Housing Factory will enable us to build up to 80 homes per
          year, providing families with safe, affordable housing. Located in
          Buffalo's East Side, this project ensures year-round construction and
          superior quality homes.
        </Description>
        <ChecklistContainer>
          <Checklist>
            <li>Produce up to 80 homes per year</li>
            <li>Year-round construction</li>
            <li>Superior quality</li>
          </Checklist>
          <Checklist>
            <li>Cost-effective and efficient</li>
            <li>Workforce development</li>
            <li>Investing in the community</li>
          </Checklist>
        </ChecklistContainer>
      </TextContent>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  background-color: var(--background-color);
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

const ImageContent = styled.div`
  max-width: 45%;
  @media (max-width: 1024px) {
    max-width: 60%;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 20px;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
`;

const TextContent = styled.div`
  max-width: 50%;
  @media (max-width: 1024px) {
    max-width: 100%;
    text-align: center;
  }
`;

const CenteredTitle = styled.h3`
  font-size: var(--font-size-subheading);
  color: var(--text-color);
  margin-bottom: 10px;
`;

const Title = styled.h1`
  font-size: 3rem;
  color: var(--text-color);
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.2;
  @media (max-width: 1024px) {
    text-align: center;
  }
`;

const Description = styled.p`
  font-size: var(--font-size-body);
  color: var(--text-color);
  margin-bottom: 20px;
`;

const ChecklistContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Checklist = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: var(--font-size-body);
  color: var(--text-color);
  flex: 1;
  &:not(:last-child) {
    margin-right: 20px;
  }
  @media (max-width: 768px) {
    &:not(:last-child) {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
  li {
    margin-bottom: 10px;
    &:before {
      content: "✓";
      color: var(--primary-color);
      margin-right: 10px;
    }
  }
`;

const LearnMoreButton = styled(Link)`
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: var(--font-size-body);
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background-color: var(--accent-color);
  }
`;

export default ModularHousingPlan;
